import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd'
import * as CasesAPI from '../api/CasesAPI'
import socket from '../api/socket'

import {
    LabOrderEventEnum,
} from '../constants/enums'

export const useCaseDetails = (caseId, provider, requestId) => {
    const [caseDetails, setCaseDetails] = useState(null)
    const [showLabOrderModal, setShowLabOrderModal] = useState(false)
    const [caseDetailsLoading, setCaseDetailsLoading] = useState(false)
    const [possessionChangeAction, setPossessionChangeAction] = useState(null)

    const fetchCaseDetails = useCallback(() => {
        setCaseDetailsLoading(true)
        CasesAPI.getCaseDetails(caseId)
            .then((res) => {
                if (res.data.payload && res.data.payload[0]) {
                    const caseData = res.data.payload[0];
                    if (!caseData._id && !caseData.id && !caseData.caseId) {
                        caseData._id = caseId;
                        caseData.id = caseId;
                        caseData.caseId = caseId;
                    }
                    setCaseDetails(caseData);
                } else {
                    setCaseDetails(null);
                }
            })
            .catch(e => {
                message.error("Unable to fetch caseDetails")
            })
            .finally(() => setCaseDetailsLoading(false))
    }, [caseId, requestId])

    const selfAssignCase = () => {
        message.info("Case assignment is not available in admin view")
    }

    const startConsultation = async () => {
        message.info("Starting consultations is not available in admin view")
        setPossessionChangeAction(null)
    };

    
    useEffect(() => {
        if (caseId) {
            fetchCaseDetails()
        }
    }, [caseId, requestId])

    useEffect(() => {
        socket.on(LabOrderEventEnum.ORDER_PLACED, async ({ caseId: id }) => {
            if (caseId === id) {
                message.success('Lab order created')
                setShowLabOrderModal(false)
                fetchCaseDetails()
            }
        })

        return () => {
            socket.removeAllListeners([
                "physicianCaseOverride",
                LabOrderEventEnum.ORDER_PLACED,
            ]);
        }
    }, [provider, caseId])

    return {
        caseDetails,
        setCaseDetails,
        caseDetailsLoading,
        fetchCaseDetails,
        selfAssignCase,
        startConsultation,
        possessionChangeAction,
        setPossessionChangeAction,
        showLabOrderModal,
        setShowLabOrderModal
    }
}
